export const META_TITLE = 'Apply for Finance Online | UDC Finance NZ'
export const META_DESCRIPTION = "Apply for finance online with UDC Finance. Complete our secure application form and we'll be in touch to help with your lending needs."

type PageMetadata = {
  title?: string
  description?: string
}

export function setPageMetadata({
  title = META_TITLE,
  description = META_DESCRIPTION,
}: PageMetadata = {}) {
  document.title = title

  let metaDescription =
    document.querySelector<HTMLMetaElement>('meta[name="description"]')

  if (!metaDescription) {
    metaDescription = document.createElement('meta')
    metaDescription.name = 'description'
    document.head.appendChild(metaDescription)
  }

  metaDescription.content = description
}